import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ArrowUturnLeftIcon, PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Dropdown, DropdownButton, DropdownBody, DropdownItem } from "@components/atoms/Dropdown";
import WorkingSetIcon from "../../tasks/components/WorkingSetIcon";

const MenuRow = ({ icon: Icon, label, onClick, danger = false }) => (
  <DropdownItem onClick={onClick} closeOnComplete>
    <span className={`flex items-center gap-2 text-sm ${danger ? "text-red-600" : ""}`}>
      <Icon aria-hidden="true" className="size-4" />
      {label}
    </span>
  </DropdownItem>
);

// Trade Accounts' title while a working set is open: the set is the page, so it replaces
// "All accounts". Its definition stays behind the menu rather than showing as filter chips.
const WorkingSetTitle = ({ set, onEdit, onRemove, onExit }) => (
  <div className="flex min-w-0 items-center gap-2">
    <Dropdown>
      <DropdownButton className="-ml-2 flex cursor-pointer items-center gap-2 rounded-md px-2 py-1 hover:bg-zinc-100">
        <WorkingSetIcon icon={set.icon} colour={set.colour} className="size-6 rounded-md" iconClassName="size-3.5" />
        <h3 className="truncate text-base font-semibold text-zinc-900">{set.name}</h3>
        <ChevronDownIcon aria-hidden="true" className="size-4 text-zinc-400" />
      </DropdownButton>
      <DropdownBody className="w-60">
        <MenuRow icon={PencilSquareIcon} label="Edit working set" onClick={onEdit} />
        <MenuRow icon={ArrowUturnLeftIcon} label="Back to all accounts" onClick={onExit} />
        <MenuRow icon={TrashIcon} label="Remove working set" danger onClick={onRemove} />
      </DropdownBody>
    </Dropdown>
    <span className="hidden shrink-0 rounded-full bg-zinc-100 px-2 py-0.5 text-[11px] font-medium text-zinc-500 sm:inline">
      Working set
    </span>
  </div>
);

export default WorkingSetTitle;
